import { customization } from '@yola/ws-sdk';
import { camelCaseObjectToSnakeCase } from 'src/js/modules/utils/convert-case';
import resolveBlockBackgroundGradientFromOverrides from 'src/js/modules/website-design/helpers/resolve-block-background-gradient-from-overrides';
import { SURFACES_ATTRIBUTE } from '../../../constants/attributes';

const isBlockWithBackgroundGradient = (block) => {
  const surfaceId = (block.getAttribute(SURFACES_ATTRIBUTE) || '').split(' ')[0];

  if (!surfaceId) {
    return false;
  }

  const colorPalette = customization.accessors.getCurrentColorPalette();
  const overrides = colorPalette?.schemes?.[surfaceId]?.variableOverrides;

  if (!overrides) {
    return false;
  }

  return (
    resolveBlockBackgroundGradientFromOverrides(camelCaseObjectToSnakeCase(overrides)) !== null
  );
};

export default isBlockWithBackgroundGradient;
